/**
 * Třída pro správu tiskových požadavků
 */
class Printer {
    constructor() {
    }

    initialize(naja) {
        // Naslouchání na AJAX success event z Naja
        naja.addEventListener('success', (event) => {
            const {payload} = event.detail;

            if (payload.printUrl) {
                this.sendPrintRequest(payload.printUrl);
            }
        });

        // Kontrola hidden inputu při načtení stránky
        this.checkPrintUrlInput();
    }

    /**
     * Kontrola a zpracování hidden inputu s printUrl
     */
    checkPrintUrlInput() {
        const printUrlInput = document.getElementById('printUrl');

        if (printUrlInput && printUrlInput.value) {
            const printUrl = printUrlInput.value;
            this.sendPrintRequest(printUrl);

            // Odstranění inputu po zpracování
            printUrlInput.remove();
        }
    }

    /**
     * Odeslání GET požadavku na print URL
     * @param {string} url - URL pro tisk
     */
    async sendPrintRequest(url) {
        try {
            console.log('Odesílám požadavek na tisk:', url);

            const response = await fetch(url, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.text();
            console.log('Tisk úspěšný:', data);

            return data;
        } catch (error) {
            console.error('Chyba při tisku:', error);
            throw error;
        }
    }
}

// Exportovat třídu
export default Printer;
